import Navigation from "./Navigation";

interface SecondaryHeaderProps {
    isMobileMenuOpen: boolean;
    closeMobileMenu: () => void;
}

export default function SecondaryHeader({ isMobileMenuOpen, closeMobileMenu }: SecondaryHeaderProps) {
    return(
        <aside className={`secondary-header ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            <Navigation closeMobileMenu={closeMobileMenu} />
        </aside>
    )
}